




























import Vue from 'vue';
import LabelDataJsonTreeView from './LabelDataJsonTreeView.vue';

export default Vue.extend({
  components: { LabelDataJsonTreeView },
  props: ['checkedLabelData'],
  data(): {
    index: number;
    maxIndex: number;
  } {
    return {
      index: 0,
      maxIndex: this.checkedLabelData.length - 1,
    };
  },
  methods: {
    previous() {
      if (this.index === 0) return;
      this.index -= 1;
    },
    next() {
      if (this.index === this.maxIndex) return;
      this.index += 1;
    },
    close() {
      this.$emit('closeModal');
    },
  },
});
